const DutchWaltz = {
    name: "Dutch Waltz",
    bpm: 138,
    signature: "3/4",
    introMeasures: 8,
    pattern: [
        { cue: '2 l o, into 1 r i prog, into 3 l o', totalBeats: 6 },
        { cue: '6 r o swing, into 6 l o swing', totalBeats: 12 },
        { cue: '2 r o, into 1 l i prog, into 3 r o', totalBeats: 6 },
        { cue: '3 l o, into 3 r i', totalBeats: 6},
        { cue: '2 l o, into 1 r i prog, into 3 l o', totalBeats: 6 },
        { cue: '6 r o swing, into 3 l o, into 3 r i', totalBeats: 12 },
        { cue: 'repeat pattern', totalBeats: 0 },
    ]
};

export default DutchWaltz;